module.exports = __webpack_public_path__ + "img/icon11.403452e4.png";